/* ============================================================
   ZAVI FINE JEWELLERY — global interactions
   Vanilla JS, framework-free. Drives the floating header,
   drawers/overlays, AJAX cart (Shopify Section Rendering API),
   predictive search, PDP, collection filters and motion.
   ============================================================ */
(function () {
  'use strict';

  var root = document.documentElement;
  var money = (window.Shopify && window.Shopify.routes) || {};
  var ROUTES = window.zaviRoutes || {};
  var STR = window.zaviStrings || {};

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------------------------------------------------------
     Header scroll state
  --------------------------------------------------------- */
  function initHeaderScroll() {
    var header = $('[data-header]');
    if (!header) return;
    var onScroll = function () {
      if (window.scrollY > 16) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------------------------------------------------
     Generic open/close for drawers + overlays
     Triggers: [data-open="<id>"], [data-close="<id>"], [data-toggle="<id>"]
     Target element: [data-drawer="<id>"] toggles .is-open
  --------------------------------------------------------- */
  var openStack = [];
  function setDrawer(id, open) {
    var el = $('[data-drawer="' + id + '"]');
    if (!el) return;
    el.classList.toggle('is-open', open);
    el.setAttribute('aria-hidden', open ? 'false' : 'true');
    var trigger = $('[data-toggle="' + id + '"]');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      if (openStack.indexOf(id) === -1) openStack.push(id);
      document.body.style.overflow = 'hidden';
      var focusable = el.querySelector('input,button,a');
      if (id === 'search' && focusable) setTimeout(function () { focusable.focus(); }, 120);
    } else {
      openStack = openStack.filter(function (x) { return x !== id; });
      if (!openStack.length) document.body.style.overflow = '';
    }
  }
  function closeAll() { openStack.slice().forEach(function (id) { setDrawer(id, false); }); }

  function initDrawers() {
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-open]');
      o ? (e.preventDefault(), setDrawer(o.getAttribute('data-open'), true)) : null;
      var c = e.target.closest('[data-close]');
      c ? ((c.tagName !== 'A' || !c.getAttribute('href') || c.getAttribute('href') === '#') ? e.preventDefault() : null, setDrawer(c.getAttribute('data-close'), false)) : null;
      var t = e.target.closest('[data-toggle]');
      t ? (e.preventDefault(), setDrawer(t.getAttribute('data-toggle'), !($('[data-drawer="' + t.getAttribute('data-toggle') + '"]') || {}).classList?.contains('is-open'))) : null;
      (e.target.hasAttribute && e.target.hasAttribute('data-scrim')) ? setDrawer(e.target.getAttribute('data-scrim'), false) : null;
    });
    document.addEventListener('keydown', function (e) { e.key === 'Escape' ? closeAll() : null; });
  }

  /* ---------------------------------------------------------
     Mega menu (hover on desktop, click toggles too)
  --------------------------------------------------------- */
  function initMega() {
    var trigger = $('[data-mega-trigger]');
    var mega = $('[data-drawer="mega"]');
    var overlay = $('[data-mega-overlay]');
    if (!trigger || !mega) return;
    var open = function (v) {
      mega.classList.toggle('is-open', v);
      if (overlay) overlay.classList.toggle('is-open', v);
      trigger.setAttribute('aria-expanded', v ? 'true' : 'false');
    };
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      open(!mega.classList.contains('is-open'));
    });
    if (overlay) overlay.addEventListener('click', function () { open(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') open(false); });
  }

  /* ---------------------------------------------------------
     Toast
  --------------------------------------------------------- */
  var toastTimer;
  function toast(msg) {
    var el = $('[data-toast]');
    if (!el) return;
    var span = $('[data-toast-msg]', el);
    if (span) span.textContent = msg;
    el.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-show'); }, 3000);
  }
  window.zaviToast = toast;

  var pendingToast = sessionStorage.getItem('zavi_toast');
  if (pendingToast) {
    sessionStorage.removeItem('zavi_toast');
    window.addEventListener('load', function () {
      setTimeout(function () { toast(pendingToast); }, 500);
    });
  }

  /* ---------------------------------------------------------
     Loader (first paint) + route progress bar
  --------------------------------------------------------- */
  function initLoader() {
    var loader = $('[data-loader]');
    if (!loader) return;
    if (sessionStorage.getItem('zaviLoaded')) { loader.classList.add('is-gone'); loader.style.transition = 'none'; return; }
    window.addEventListener('load', function () {
      setTimeout(function () { loader.classList.add('is-gone'); sessionStorage.setItem('zaviLoaded', '1'); }, 1100);
    });
    // safety: never trap the page
    setTimeout(function () { loader.classList.add('is-gone'); }, 4000);
  }
  function initProgress() {
    var bar = $('[data-progress]');
    if (!bar) return;
    window.addEventListener('pageshow', function () { bar.className = 'z-progress'; });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (a.target === '_blank' || a.hasAttribute('data-no-progress')) return;
      if (href && href[0] !== '#' && !href.startsWith('mailto:') && !href.startsWith('tel:') &&
          (a.host === window.location.host)) {
        bar.classList.add('is-active');
      }
    });
    window.addEventListener('beforeunload', function () { bar.classList.add('is-active'); });
  }

  /* ---------------------------------------------------------
     Reveal on scroll
  --------------------------------------------------------- */
  function initReveal() {
    var els = $$('[data-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------
     Cart — AJAX add / change, Section Rendering refresh
  --------------------------------------------------------- */
  function refreshCartSections() {
    return fetch((ROUTES.cart_url || '/cart') + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-inner]');
        var current = $('[data-cart-drawer-inner]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      })
      .then(updateCartCount);
  }
  function syncBackendCart(cartData) {
    var cust = window.zaviCustomer || (localStorage.getItem('zavi_user_email') ? { email: localStorage.getItem('zavi_user_email'), customerId: localStorage.getItem('zavi_customer_id') || '' } : null);
    var api = window.zaviApiBase || window.zaviCartApiBase;
    return (!cust || !cust.email || !api)
      ? Promise.resolve(null)
      : fetch(api + '/api/cart', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            actionType: 'sync',
            email: cust.email,
            customerId: cust.customerId || '',
            cartId: localStorage.getItem('zavi_cart_id') || '',
            lines: (cartData.items || []).map(function (item) {
              return {
                merchandiseId: 'gid://shopify/ProductVariant/' + item.variant_id,
                quantity: item.quantity
              };
            })
          })
        })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          res && res.cart && res.cart.id && localStorage.setItem('zavi_cart_id', res.cart.id);
          res && res.cart && res.cart.checkoutUrl && (window.zaviCartCheckoutUrl = res.cart.checkoutUrl, localStorage.setItem('zavi_checkout_url', res.cart.checkoutUrl));
          return res;
        })
        .catch(function () { return null; });
  }

  function updateCartCount() {
    return fetch((ROUTES.cart_url || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          cart.item_count > 0
            ? (el.hidden = false, el.classList.remove('is-bump'), void el.offsetWidth, el.classList.add('is-bump'))
            : (el.hidden = true);
        });
        syncBackendCart(cart);
        return cart;
      });
  }

  function addToCart(payload, opts) {
    opts = opts || {};
    var cust = window.zaviCustomer || (localStorage.getItem('zavi_user_email') ? { email: localStorage.getItem('zavi_user_email') } : null);
    return (!cust || !cust.email)
      ? (function () {
          toast('Please log in to add to bag');
          setTimeout(function () { window.location.href = '/pages/login'; }, 800);
          return Promise.resolve();
        })()
      : (function () {
    return fetch((ROUTES.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    }).then(function (res) {
      var item = (res && res.items && res.items[0]) || res;
      return refreshCartSections().then(function () {
        if (opts.openDrawer !== false) setDrawer('cart', true);
        toast((item.product_title || (STR.added_prefix || 'Added')) + (STR.added_suffix || ' is added to your bag'));
        document.dispatchEvent(new CustomEvent('zavi:cart:added', { detail: item }));
      });
    }).catch(function (err) {
      toast((err && err.description) || STR.cart_error || 'Could not add to bag');
    });
        })();
  }
  window.zaviAddToCart = addToCart;

  function changeLine(line, quantity) {
    return fetch((ROUTES.cart_change_url || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function initCart() {
    // product card / quick-add buttons: [data-add-id="<variantId>"]
    document.addEventListener('click', function (e) {
      var qa = e.target.closest('[data-add-id]');
      if (qa) {
        e.preventDefault(); e.stopPropagation();
        var id = qa.getAttribute('data-add-id');
        if (!id) { toast(STR.unavailable || 'Currently unavailable'); return; }
        qa.classList.add('is-loading');
        addToCart({ items: [{ id: id, quantity: 1 }] }).then(function () { qa.classList.remove('is-loading'); });
        return;
      }
      var wish = e.target.closest('[data-wishlist]');
      wish && (function () {
        e.preventDefault(); e.stopPropagation();
        var pid = wish.getAttribute('data-wishlist');
        var cust = window.zaviCustomer || (localStorage.getItem('zavi_user_email') ? { email: localStorage.getItem('zavi_user_email') } : null);
        var api = window.zaviApiBase;

        var isHeaderWish = !pid;

        isHeaderWish && (function () {
          var dest = (cust && cust.email) ? '/pages/account#wishlist-desktop' : '/pages/login';
          window.location.href = dest;
        })();

        (!isHeaderWish) && (function () {
          (!cust || !cust.email) && (function () {
            toast('Please log in to save to wishlist');
            setTimeout(function () { window.location.href = '/pages/login'; }, 800);
          })();

          (cust && cust.email && pid && api) && (function () {
            var isAlready = wish.classList.contains('is-wishlisted');
            var action = isAlready ? 'remove' : 'add';
            wish.classList.add('is-loading');
            fetch(api + '/api/wishlist', {
              method: 'POST',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
              body: new URLSearchParams({ actionType: action, email: cust.email, productId: pid }).toString()
            })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              wish.classList.remove('is-loading');
              data.success && (isAlready
                ? (wish.classList.remove('is-wishlisted'), toast('Removed from wishlist'))
                : (wish.classList.add('is-wishlisted'), toast(STR.wishlist || 'Saved to your wishlist')));
              !data.success && toast(data.error || 'Could not save');
            })
            .catch(function () {
              wish.classList.remove('is-loading');
              toast('Could not save to wishlist');
            });
          })();
        })();
      })();
    });

    (function () {
      var cust = window.zaviCustomer || (localStorage.getItem('zavi_user_email') ? { email: localStorage.getItem('zavi_user_email') } : null);
      var api = window.zaviApiBase;
      (cust && cust.email && api) && fetch(api + '/api/wishlist?email=' + encodeURIComponent(cust.email), {
        headers: { 'ngrok-skip-browser-warning': '1' }
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var ids = (data.productIds || []).map(function (id) { return String(id).replace(/\D/g, ''); });
          document.querySelectorAll('[data-wishlist]').forEach(function (btn) {
            var pid = String(btn.getAttribute('data-wishlist') || '').replace(/\D/g, '');
            pid && ids.indexOf(pid) !== -1 && btn.classList.add('is-wishlisted');
          });
        })
        .catch(function () {});
    })();

    // PDP add-to-cart form
    var form = $('[data-product-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.classList.add('is-loading');
        addToCart({ items: [{ id: form.querySelector('[name="id"]').value, quantity: Number((form.querySelector('[name="quantity"]') || {}).value || 1) }] })
          .then(function () { if (btn) btn.classList.remove('is-loading'); });
      });
    }

    // delegated qty change + remove inside cart drawer & cart page (AJAX)
    var lineChangeBusy = {};
    document.addEventListener('click', function (e) {
      var ctl = e.target.closest('[data-line-change]');
      if (!ctl) return;
      var line = ctl.getAttribute('data-line');
      if (lineChangeBusy[line]) return;
      e.preventDefault();
      var dir = ctl.getAttribute('data-line-change');
      var wrap = ctl.closest('[data-line-item]');
      var current = Number(wrap ? wrap.getAttribute('data-qty') : 0);
      var deltas = { remove: -current, inc: 1, dec: -1 };
      var next = Math.max(0, current + (deltas[dir] || 0));
      lineChangeBusy[line] = true;
      changeLine(Number(line), next).then(function () {
        return refreshCartSections();
      }).then(function () {
        lineChangeBusy[line] = false;
        var cartMain = $('[data-cart-main]');
        return cartMain && fetch((ROUTES.cart_url || '/cart') + '?section_id=main-cart')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-cart-main]');
            fresh && (cartMain.innerHTML = fresh.innerHTML);
          });
      }).catch(function () {
        lineChangeBusy[line] = false;
      });
    });

    document.addEventListener('click', function (e) {
      var chkBtn = e.target.closest('[name="checkout"]:not([data-quote-open-btn]), [data-checkout-btn]');
      var cust = window.zaviCustomer || (localStorage.getItem('zavi_user_email') ? { email: localStorage.getItem('zavi_user_email') } : null);
      var mail = (cust && cust.email) || localStorage.getItem('zavi_user_email') || '';
      var api = window.zaviApiBase;

      chkBtn && (e.preventDefault(), (function () {
        var baseUrl = window.zaviCartCheckoutUrl || localStorage.getItem('zavi_checkout_url') || '/checkout';
        (!mail || !api) && (window.location.href = baseUrl);

        (mail && api) && (function () {
          chkBtn.classList.add('is-loading');
          fetch(api + '/api/customer?email=' + encodeURIComponent(mail), {
            headers: { 'ngrok-skip-browser-warning': '1' }
          })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            var c = (res && res.customer) || {};
            var addr = c.defaultAddress || {};
            var fn = c.firstName || addr.firstName || (localStorage.getItem('zavi_user_name') || '').split(' ')[0] || '';
            var ln = c.lastName || addr.lastName || (localStorage.getItem('zavi_user_name') || '').split(' ').slice(1).join(' ') || '';

            var params = new URLSearchParams();
            mail && params.set('checkout[email]', mail);
            fn && params.set('checkout[shipping_address][first_name]', fn);
            ln && params.set('checkout[shipping_address][last_name]', ln);
            addr.address1 && params.set('checkout[shipping_address][address1]', addr.address1);
            addr.address2 && params.set('checkout[shipping_address][address2]', addr.address2);
            addr.city && params.set('checkout[shipping_address][city]', addr.city);
            addr.province && params.set('checkout[shipping_address][province]', addr.province);
            addr.zip && params.set('checkout[shipping_address][zip]', addr.zip);
            addr.country && params.set('checkout[shipping_address][country]', addr.country || 'India');
            (addr.phone || c.phone) && params.set('checkout[shipping_address][phone]', addr.phone || c.phone);

            var finalUrl = baseUrl + (baseUrl.indexOf('?') !== -1 ? '&' : '?') + params.toString();
            window.location.href = finalUrl;
          })
          .catch(function () {
            window.location.href = baseUrl;
          });
        })();
      })());
    });
  }

  /* ---------------------------------------------------------
     Predictive search
  --------------------------------------------------------- */
  function initSearch() {
    var input = $('[data-predictive-input]');
    var out = $('[data-predictive-results]');
    var empty = $('[data-predictive-empty]');
    if (!input || !out) return;
    var t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (!q) { out.innerHTML = ''; if (empty) empty.hidden = true; return; }
      t = setTimeout(function () {
        var url = (ROUTES.predictive_search_url || '/search/suggest') +
          '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][prefix]=last';
        fetch(url).then(function (r) { return r.json(); }).then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          // Shopify's native search does broad/semantic matching and can return
          // products with no textual relation to the query; filter those out.
          var queryWords = q.toLowerCase().split(/\s+/).filter(Boolean);
          // Two tokens match if they're equal, or if they share a common prefix of
          // at least 3 chars (handles plural/singular in either direction, e.g.
          // "ring"/"rings" or "earrings"/"earring"), without matching unrelated
          // words that merely contain the query as a substring (e.g. "earrings").
          function tokensMatch(a, b) {
            if (a === b) return true;
            var common = Math.min(a.length, b.length);
            return common >= 3 && a.slice(0, common) === b.slice(0, common);
          }
          var categoryMap = window.ZAVI_CATEGORY_MAP || {};
          products = products.filter(function (p) {
            var category = categoryMap[p.handle] || '';
            var haystack = [p.title, p.product_type, p.vendor, (p.tags || []).join(' '), category].join(' ').toLowerCase();
            var haystackWords = haystack.split(/\s+/).filter(Boolean);
            return queryWords.every(function (word) {
              return haystackWords.some(function (hw) { return tokensMatch(hw, word); });
            });
          });
          out.innerHTML = products.map(function (p) {
            var img = (p.featured_image && p.featured_image.url) || (p.image) || '';
            return '<a href="' + p.url + '"><span class="thumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span>' +
              '<span class="nm">' + p.title + '</span></a>';
          }).join('');
          if (empty) empty.hidden = products.length > 0;
        }).catch(function () {});
      }, 220);
    });
  }

  /* ---------------------------------------------------------
     Accordions (PDP)
  --------------------------------------------------------- */
  function initAccordions() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-acc-btn]');
      if (!btn) return;
      var item = btn.closest('[data-acc-item]');
      var group = btn.closest('[data-acc-group]');
      var isOpen = item.classList.contains('is-open');
      if (group && group.hasAttribute('data-acc-single')) {
        $$('[data-acc-item]', group).forEach(function (i) { i.classList.remove('is-open'); });
      }
      item.classList.toggle('is-open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  /* ---------------------------------------------------------
     PDP gallery + variant swatches + qty steppers
  --------------------------------------------------------- */
  function initPdp() {
    // gallery thumbnails
    $$('[data-gallery]').forEach(function (gal) {
      var main = $('[data-gallery-main]', gal);
      $$('[data-gallery-thumb]', gal).forEach(function (th) {
        th.addEventListener('click', function () {
          var src = th.getAttribute('data-src');
          if (main && src) main.src = src;
          $$('[data-gallery-thumb]', gal).forEach(function (x) { x.classList.remove('is-active'); });
          th.classList.add('is-active');
        });
      });
    });

    // variant selection (metal swatches / option buttons)
    var form = $('[data-product-form]');
    if (form && window.zaviVariants) {
      var idInput = form.querySelector('[name="id"]');
      $$('[data-variant-option]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.getAttribute('data-option-group');
          $$('[data-variant-option][data-option-group="' + group + '"]').forEach(function (x) { x.classList.remove('is-active'); });
          btn.classList.add('is-active');
          // compute selected options
          var chosen = {};
          $$('[data-variant-option].is-active').forEach(function (x) {
            chosen[x.getAttribute('data-option-group')] = x.getAttribute('data-option-value');
          });
          var match = window.zaviVariants.find(function (v) {
            return v.options.every(function (val, i) {
              var gk = 'option' + (i + 1);
              return chosen[gk] === undefined || chosen[gk] === val;
            });
          });
          if (match && idInput) {
            idInput.value = match.id;
            var nm = $('[data-selected-option="' + group + '"]');
            if (nm) nm.textContent = btn.getAttribute('data-option-value');
            var priceEl = $('[data-variant-price]');
            if (priceEl && match.priceText) priceEl.textContent = match.priceText;
          }
        });
      });
    }

    // qty steppers (PDP + anywhere with [data-qty-wrap])
    $$('[data-qty-wrap]').forEach(function (wrap) {
      var input = $('input', wrap);
      $$('[data-qty-step]', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = Number(btn.getAttribute('data-qty-step'));
          var v = Math.max(1, (Number(input.value) || 1) + dir);
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------------------------------------------------------
     Sort dropdown (collection)
  --------------------------------------------------------- */
  function initSort() {
    var sort = $('[data-sort]');
    if (!sort) return;
    var btn = $('[data-sort-toggle]', sort);
    btn.addEventListener('click', function (e) { e.stopPropagation(); sort.classList.toggle('is-open'); });
    document.addEventListener('click', function () { sort.classList.remove('is-open'); });
    $$('[data-sort-value]', sort).forEach(function (opt) {
      opt.addEventListener('click', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', opt.getAttribute('data-sort-value'));
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ---------------------------------------------------------
     Init
  --------------------------------------------------------- */
  function init() {
    initHeaderScroll();
    initDrawers();
    initMega();
    initLoader();
    initProgress();
    initReveal();
    initCart();
    initSearch();
    initAccordions();
    initPdp();
    initSort();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
